<template lang="pug">
  div {{ title }}
</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import {DocumentStateTitleFilter} from '@/views/pages/finance/accounts/accountspage';

@Component({
  name: 'history-document-status-title',
  filters: {
    title: DocumentStateTitleFilter,
  },
})
export default class DocumentStatusTitle extends Vue {
  @Prop({required: true})
  document!: boolean

  @Prop({default: 'Платеж исполнен.'})
  titleExecuted!: string

  @Prop({default: 'Платеж переведен на ручную обработку. Наш персонал постарается обработать вашу заявку максимально быстро. Благодарим за понимание.'})
  titleManualProcess!: string

  @Prop({default: 'Платеж отклонен.'})
  titleDeclined!: string

  @Prop({default: 'Платеж в обработке.'})
  titleInprocess!: string

  get title() {
    return this.$t(DocumentStateTitleFilter(this.document,
      this.titleManualProcess,
      this.titleInprocess,
      this.titleExecuted,
      this.titleDeclined))
  }
}
</script>

<style scoped lang="less">

</style>

<i18n>
{
  "en": {
    "Платеж исполнен.": "Payment is executed.",
    "Платеж переведен на ручную обработку. Наш персонал постарается обработать вашу заявку максимально быстро. Благодарим за понимание.": "Payment is transferred to manual processing. Our staff will try to process your request as soon as possible. Thank you for understanding.",
    "Платеж отклонен.": "Payment is declined.",
    "Платеж в обработке.": "Payment is in processing."
  }
}
</i18n>
